import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as mdi from '@mdi/js'
import { aliases as mdiAliases } from 'vuetify/iconsets/mdi'
import { en, pt } from 'vuetify/locale'
// import { MdiSvg } from 'vuetify/iconsets/mdi-svg'
import { ref, h } from 'vue'

import AppGuideIcon from '@/assets/icons/AppGuideIcon.vue'
import AppGuide_Icon from '@/assets/icons/AppGuide_Icon.vue'
import BookMark from '@/assets/icons/BookMark.vue'
import BookMarkGrn from '@/assets/icons/BookMarkGrn.vue'
import GuideIcon from '@/assets/icons/GuideIcon.vue'
import CoursesIcon from '@/assets/icons/CoursesIcon.vue'
import Courses_Icon from '@/assets/icons/Courses_Icon.vue'
import Sections_Icon from '@/assets/icons/Sections_Icon.vue'
import SectionsIcon from '@/assets/icons/SectionsIcon.vue'
import UnitsIcon from '@/assets/icons/UnitsIcon.vue'
import GroupsIcon from '@/assets/icons/GroupsIcon.vue'
import UsersIcon from '@/assets/icons/UsersIcon.vue'
import FaqIcon from '@/assets/icons/FaqIcon.vue'
import LogoutIcon from '@/assets/icons/LogoutIcon.vue'
import LogoIcon from '@/assets/icons/LogoIcon.vue'
import ArrowLeft from '@/assets/icons/ArrowLeft.vue'
import ArrowRight from '@/assets/icons/ArrowRight.vue'
import ArrowDown from '@/assets/icons/ArrowDown.vue'
import ArrowUp from '@/assets/icons/ArrowUp.vue'
import MenuIcon from '@/assets/icons/MenuIcon.vue'
import ProfileIcon from '@/assets/icons/ProfileIcon.vue'
import UserFaqIcon from '@/assets/icons/UserFaqIcon.vue'
import AdminIcon from '@/assets/icons/AdminIcon.vue'
import UserLogoutIcon from '@/assets/icons/UserLogoutIcon.vue'
import DeleteIcon from '@/assets/icons/DeleteIcon.vue'
import EditIcon from '@/assets/icons/EditIcon.vue'
import PencilIcon from '@/assets/icons/PencilIcon.vue'
import NotePencilIcon from '@/assets/icons/NotePencilIcon.vue'
import NotificationsIcon from '@/assets/icons/NotificationsIcon.vue'
import QuestionMark from '@/assets/icons/QuestionMark.vue'
import DragIcon from '@/assets/icons/DragIcon.vue'
import LinkIcon from '@/assets/icons/LinkIcon.vue'
import MediaIcon from '@/assets/icons/MediaIcon.vue'
import MediaIconBtn from '@/assets/icons/MediaIconBtn.vue'
import TwoPeople from '@/assets/icons/TwoPeople.vue'
import ThreePeople from '@/assets/icons/ThreePeople.vue'
import SortArrowDown from '@/assets/icons/SortArrowDown.vue'
import MissionsIcon from '@/assets/icons/MissionsIcon.vue'
import Missions_Icon from '@/assets/icons/Missions_Icon.vue'
import MissionsIconOutline from '@/assets/icons/MissionsIconOutline.vue'
import Lock from '@/assets/icons/Lock.vue'
import LockOpen from '@/assets/icons/LockOpen.vue'
import Category from '@/assets/icons/Category.vue'
import CalendarIcon from '@/assets/icons/CalendarIcon.vue'
import RibbonIcon from '@/assets/icons/RibbonIcon.vue'
import DownloadIcon from '@/assets/icons/DownloadIcon.vue'
import ApiIcon from '@/assets/icons/ApiIcon.vue'
import CodeIcon from '@/assets/icons/CodeIcon.vue'
import EmailIcon from '@/assets/icons/EmailIcon.vue'
import MailIcon from '@/assets/icons/MailIcon.vue'
import PhoneIcon from '@/assets/icons/PhoneIcon.vue'
import EyeIcon from '@/assets/icons/EyeIcon.vue'
import GoogleIcon from '@/assets/icons/GoogleIcon.vue'
import PrivacyIcon from '@/assets/icons/PrivacyIcon.vue'
import InvertColors from '@/assets/icons/InvertColors.vue'
import LanguageIcon from '@/assets/icons/LanguageIcon.vue'

export const currentTheme = ref('light')

const iconMap = {
  appguide_icon: AppGuideIcon,
  appguideicon: AppGuide_Icon,
  arrowdown: ArrowDown,
  arrowleft: ArrowLeft,
  arrowright: ArrowRight,
  arrowup: ArrowUp,
  bookmark: BookMark,
  bookmarkgrn: BookMarkGrn,
  guide: GuideIcon,
  courses: CoursesIcon,
  courses_icon: Courses_Icon,
  sections: SectionsIcon,
  sections_icon: Sections_Icon,
  units: UnitsIcon,
  groups: GroupsIcon,
  users: UsersIcon,
  faq: FaqIcon,
  menu_icon: MenuIcon,
  profile: ProfileIcon,
  userfaq: UserFaqIcon,
  admin: AdminIcon,
  user_logout: UserLogoutIcon,
  logout: LogoutIcon,
  logo_icon: LogoIcon,
  delete_icon: DeleteIcon,
  edit: EditIcon,
  pencil: PencilIcon,
  notepencil: NotePencilIcon,
  notifications: NotificationsIcon,
  question_mark: QuestionMark,
  drag_icon: DragIcon,
  link: LinkIcon,
  media: MediaIcon,
  media_btn: MediaIconBtn,
  twopeople: TwoPeople,
  threepeople: ThreePeople,
  sortarrowdown: SortArrowDown,
  missions: MissionsIcon,
  mission_outline: MissionsIconOutline,
  missions_icon: Missions_Icon,
  lock: Lock,
  lock_open: LockOpen,
  category: Category,
  calendar: CalendarIcon,
  ribbon: RibbonIcon,
  download: DownloadIcon,
  api: ApiIcon,
  code: CodeIcon,
  emailicon: EmailIcon,
  mailicon: MailIcon,
  phoneicon: PhoneIcon,
  eye: EyeIcon,
  google: GoogleIcon,
  privacy: PrivacyIcon,
  invert_colors: InvertColors,
  language: LanguageIcon,
}

// ✅ Auto-generate aliases for all custom icons
const customAliases = Object.keys(iconMap).reduce((acc, key) => {
  acc[key] = { icon: key, iconSet: 'custom' }
  return acc
}, {})

export default createVuetify({
    components,
    directives,
    // Vuetify's own text (tables, pickers, pagination); switched with the site language in setSiteLocale.
    locale: {
      locale: 'en',
      fallback: 'en',
      messages: { en, pt },
    },
    theme: {
      defaultTheme: currentTheme,
      themes: {
        light: {
          dark: false,
          colors: {
            primary: '#592892',
            secondary: '#b0bec5',
            accent: '#8c9eff',
            error: '#b71c1c',
            blueyear: '#002B45',
            greenyear: '#024731',
            redyear: '#6E273D',
            background: '#fff',
            adminBackground: 'rgba(165, 216, 103, .14)',
            adminMenuBackground: '#cfebae',
            secondaryNavBackground: '#e9f5d7',
            'on-surface': '#231815',     // default icon/text color on surfaces
            'on-background': '#231815',  // default icon/text color on background
          }
        },
        dark: {
          dark: true,
          colors: {
            blueyear: '#002B45',
            greenyear: '#024731',
            redyear: '#6E273D',
            background: '#1e1e1e',                 // slightly off-black base
            surface: '#272727',                    // header (.v-toolbar)
            adminBackground: '#121212',
            adminMenuBackground: '#363636',        // .custom-drawer-bg
            secondaryNavBackground: '#4b4b4b',     // .custom-second-drawer-bg
            'on-surface': '#CECECE', // light icon/text on dark surface
            'on-background': '#CECECE',
          },
          variables: {
            'second-drawer-surface': '#4b4b4b'
          },
        }
      }
    },
    defaults: {
      global: {
        style: {
          fontFamily: '"museo-sans", sans-serif',
        },
      },
    },
    typography: {
      defaultFontFamily: '"museo-sans", sans-serif',
    },
    icons: {
    defaultSet: 'custom',
    aliases: {
      ...mdiAliases,
      ...customAliases,
      clear: 'mdi-close',
      close: 'mdi-close',
      menu: 'mdi-menu',
      dropdown: 'mdi-menu-down',
      cached: 'mdi-cached',
    },
    sets: {
      custom: {
        component: (props) => {
          const iconName = props.icon
          const Comp = iconMap[iconName]
          if (Comp) {
            const currentThemeIsDark = currentTheme.value === 'dark'

            const pathname = window?.location?.pathname || '/'
            const routeName = pathname.replace('/', '')
            const isNotAdmin = ['Home', 'Login', 'License', 'Welcome', 'Unit', ''].includes(routeName)

            const isLogout = ['logout', 'user_logout'].includes(iconName)
            const fillColor = isLogout
              ? currentThemeIsDark ? '#cecece' : '#383935'
              : currentThemeIsDark
                ? 'rgb(165, 216, 103)'
                : isNotAdmin
                  ? 'rgb(165, 216, 103)'
                  : '#ffffff'

            return h(Comp, { color: fillColor })
          }

          let mdiKey = iconName.startsWith('mdi-')
            ? 'mdi' + iconName.slice(4).split('-').map(p => p.charAt(0).toUpperCase() + p.slice(1)).join('')
            : 'mdi' + iconName.split('-').map(p => p.charAt(0).toUpperCase() + p.slice(1)).join('')

          const pathData = mdi[mdiKey]
          if (typeof pathData === 'string') {
            return h('v-icon', {
              class: 'v-icon',
              role: 'button',
              tabindex: 0,
              'aria-hidden': false,
              onClick: props.onClick || (() => {}), // ensures click works
              innerHTML: `<svg class="v-icon__svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="${pathData}" /></svg>`
            })
          }

          console.warn(`❌ Unknown icon: "${iconName}"`)
          return h('span', {}, iconName)
        }
      },
      mdi: {
        icons: Object.fromEntries(
          Object.entries(mdi).map(([key, val]) => [key.replace(/^mdi/, 'mdi-').toLowerCase(), val])
        )
      }
    }
  }

})
